<template>
  <div class="">
    <b-button v-b-toggle.theTreasuries class="btn btn-lg btn-collapse">
      {{ $t("theTreasuries") }}
      <i class="fa fa-angle-down" aria-hidden="true"></i>
    </b-button>
    <b-collapse id="theTreasuries">
      <div class="my-card">
        <div class="row">
          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="establishmentTreasuryView"
              v-model="usersPrivilegeTreasuries.establishmentTreasuryView"
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="establishmentTreasuryView">{{
              $t("view")
            }}</label>
          </div>
          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="establishmentTreasuryAdd"
              v-model="usersPrivilegeTreasuries.establishmentTreasuryAdd"
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="establishmentTreasuryAdd">{{
              $t("add")
            }}</label>
          </div>
          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="establishmentTreasuryUpdate"
              v-model="usersPrivilegeTreasuries.establishmentTreasuryUpdate"
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="establishmentTreasuryUpdate">{{
              $t("edit")
            }}</label>
          </div>

          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="establishmentTreasuryArchive"
              v-model="usersPrivilegeTreasuries.establishmentTreasuryArchive"
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="establishmentTreasuryArchive">{{
              $t("archive")
            }}</label>
          </div>
          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="establishmentTreasuryDelete"
              v-model="usersPrivilegeTreasuries.establishmentTreasuryDelete"
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="establishmentTreasuryDelete">{{
              $t("finalDelete")
            }}</label>
          </div>
          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="establishmentTreasuryRestore"
              v-model="usersPrivilegeTreasuries.establishmentTreasuryRestore"
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="establishmentTreasuryRestore">{{
              $t("restore")
            }}</label>
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: "UsersPrivilegeTreasuries",
  data() {
    return {
      language: localStorage.getItem("userLanguage") || "ar",
    };
  },
  props: ["usersPrivilegeTreasuries"],
  methods: {},
};
</script>

<style scoped lang="scss"></style>
